import { QRCodeCanvas } from "qrcode.react";
import { fmtDate } from "@/lib/api";

export const verifyUrl = (no) => `${window.location.origin}/verify/rx/${no}`;

export function RxSheet({ rx }) {
  const d = rx.doctor;
  return (
    <div className="rx-sheet relative mx-auto w-full max-w-[560px] bg-white p-7 text-[13px] text-slate-800 shadow-xl ring-1 ring-slate-200" data-testid="rx-sheet">
      {rx.status === "VOIDED" && <div className="pointer-events-none absolute inset-0 grid place-items-center"><span className="rotate-[-18deg] rounded-xl border-4 border-red-500 px-6 py-2 text-4xl font-black text-red-500/80">VOIDED</span></div>}
      <div className="border-b-2 border-purple-700 pb-3 text-center">
        <p className="text-lg font-extrabold uppercase tracking-wide">{d.display_name}</p>
        <p className="text-xs">{d.specialty}</p>
        <p className="text-xs">{d.clinic_name}{d.clinic_address ? ` · ${d.clinic_address}` : ""}{d.clinic_contact ? ` · ${d.clinic_contact}` : ""}</p>
      </div>
      <div className="mt-3 grid grid-cols-4 gap-x-3 gap-y-1 text-xs">
        <p className="col-span-3">Patient: <b>{rx.patient.name}</b></p><p>Date: <b>{fmtDate(rx.issued_at || new Date().toISOString())}</b></p>
        <p>Age: <b>{rx.patient.age ?? "—"}</b></p><p>Sex: <b>{rx.patient.sex || "—"}</b></p><p className="col-span-2">Address: <b>{rx.patient.address || "—"}</b></p>
      </div>
      <p className="mt-4 font-serif text-5xl font-black italic text-purple-800">℞</p>
      <ol className="mt-2 min-h-[160px] space-y-3">
        {rx.items.map((m, i) => (
          <li key={i} data-testid={`rx-item-${i}`}>
            <p className="font-bold">{i + 1}. {m.generic} {m.strength}{m.brand ? <span className="font-normal"> ({m.brand})</span> : null} <span className="float-right">#{m.quantity}</span></p>
            <p className="pl-4 italic">Sig: {m.sig}</p>
          </li>
        ))}
      </ol>
      {rx.notes && <p className="mt-2 text-xs">Notes: {rx.notes}</p>}
      {rx.follow_up && <p className="text-xs">Follow-up: <b>{fmtDate(rx.follow_up)}</b></p>}
      <div className="mt-6 flex items-end justify-between gap-4">
        <div className="text-center">
          {rx.number && <QRCodeCanvas value={verifyUrl(rx.number)} size={84} />}
          <p className="mt-1 font-mono text-[10px]" data-testid="rx-number">{rx.number || "Preview · not issued"}</p>
        </div>
        <div className="min-w-[200px] text-center text-xs">
          {rx.signature && <img src={rx.signature} alt="Signature" className="mx-auto h-14 object-contain" />}
          <p className="border-t border-slate-500 pt-1 font-bold">{d.display_name}</p>
          <p>PRC No. {d.prc_no}{d.ptr_no ? ` · PTR ${d.ptr_no}` : ""}{d.s2_no ? ` · S2 ${d.s2_no}` : ""}</p>
        </div>
      </div>
    </div>
  );
}

export function CouponTicket({ c }) {
  const dim = c.status !== "AVAILABLE";
  return (
    <div className={`relative overflow-hidden rounded-3xl bg-gradient-to-br from-violet-700 to-blue-600 p-5 text-white shadow-xl ${dim ? "grayscale" : ""}`} data-testid={`coupon-${c.code}`}>
      {dim && <span className="absolute right-4 top-4 rotate-12 rounded-lg border-2 border-white px-2 text-sm font-black">{c.status}</span>}
      <div className="flex items-center gap-3"><img src="/logo-mark.png" alt="" className="h-10 w-10 rounded-full bg-white p-0.5" /><div><p className="text-xs uppercase tracking-widest opacity-80">GIAcare+ · {c.package_name}</p><p className="text-xl font-extrabold">FREE APPOINTMENT</p></div></div>
      <div className="mt-4 flex items-end justify-between gap-3">
        <div className="text-xs">
          <p>Member: <b>{c.member_name}</b></p>
          <p>Coupon {c.seq} of {c.of} · valid until <b>{fmtDate(c.expires_at)}</b></p>
          <p className="mt-1 font-mono text-sm font-bold" data-testid="coupon-code">{c.code}</p>
          <div className="mt-2 rounded-lg bg-white/95 px-2 py-1 text-slate-800">
            {c.signature && <img src={c.signature} alt="Signature" className="h-8 object-contain" />}
            <p className="text-[10px] font-bold">{c.signer?.name}{c.signer?.prc_no ? ` · PRC ${c.signer.prc_no}` : ""}</p>
          </div>
        </div>
        <div className="rounded-xl bg-white p-2"><QRCodeCanvas value={c.code} size={88} /></div>
      </div>
      {c.used_at && <p className="mt-2 text-[11px] opacity-90">Used {fmtDate(c.used_at)} · {c.used_by_name}</p>}
    </div>
  );
}
